import store from '../../store'
import { PRODUCT_LIST } from '../../common/constants/ProductConstants'

export const CONDITIONS = {
    CAN_USE_CUSTOM_PROJECT_STYLES: 'CAN_USE_CUSTOM_PROJECT_STYLES',
    CAN_USE_CUSTOM_PROJECT_TRANSLATIONS: 'CAN_USE_CUSTOM_PROJECT_TRANSLATIONS',
    CAN_USE_GAMIFICATION: 'CAN_USE_GAMIFICATION',
    CAN_USE_SDK_INTEGRATION: 'CAN_USE_SDK_INTEGRATION',
    CAN_USE_LEAD_FORM_IN_BLOCKS: 'CAN_USE_LEAD_FORM_IN_BLOCKS',
    CAN_USE_FULL_STATISTICS: 'CAN_USE_FULL_STATISTICS',
}

const isTestUser = ({ isTest }) => isTest
const isEnterpriseSubscription = productCode =>
    productCode === PRODUCT_LIST.Enterprise || productCode === PRODUCT_LIST.EnterpriseYear

const CONDITIONS_RULES = {
    [CONDITIONS.CAN_USE_CUSTOM_PROJECT_STYLES]: ({ user, productCode }) =>
        isTestUser(user) || isEnterpriseSubscription(productCode),
    [CONDITIONS.CAN_USE_CUSTOM_PROJECT_TRANSLATIONS]: ({ user, productCode }) =>
        isTestUser(user) || isEnterpriseSubscription(productCode),
    [CONDITIONS.CAN_USE_GAMIFICATION]: ({ user, featureList }) =>
        isTestUser(user) || featureList.includes('GAMIFICATION'),
    [CONDITIONS.CAN_USE_SDK_INTEGRATION]: ({ user, featureList }) =>
        isTestUser(user) || featureList.includes('SDK_INTEGRATION'),
    [CONDITIONS.CAN_USE_LEAD_FORM_IN_BLOCKS]: ({ user, featureList }) =>
        isTestUser(user) || featureList.includes('LEAD_COLLECTION_FORM'),
    [CONDITIONS.CAN_USE_FULL_STATISTICS]: ({ user, featureList }) =>
        isTestUser(user) || featureList.includes('FULL_STATISTICS'),
}

export const hasPermission = (conditions = []) => {
    const { user_subscription, user_details } = store.getState()
    let result = true
    for (const condition of Array.isArray(conditions) ? conditions : [conditions]) {
        if (!CONDITIONS.hasOwnProperty(condition)) {
            result = false
            break
        }

        const isAllowed = CONDITIONS_RULES[condition]({
            user: user_details,
            productCode: user_subscription.product.productCode,
            featureList: user_subscription.product.featureProducts.map(el => el.featureType),
        })
        if (!isAllowed) {
            result = false
            break
        }
    }
    return result
}
